export default __webpack_public_path__ + "static/media/dynamic-allround-chem-arc.d5ba521b.png";